<div class="wrap">
  <div class="left">
    <app-svg-icon [name]="'wallet'"></app-svg-icon>
    <app-price-label
      [value]="subsidyAmount | appCurrency | async"
      [isCompact]="true"
      [noIcon]="true"
    ></app-price-label>
    <app-svg-icon
      [name]="'info'"
      [color]="'color-primary'"
      (click)="infoClicked.next()"
      class="info-icon"
    ></app-svg-icon>
  </div>
  <div class="cta-button" (click)="ctaClicked.next()">
    {{ "@components.subsidyWalletBadge.cta" | translate }}
  </div>
</div>
